import * as postVideoActions from '../../action_creators/post/post_video_action_creators';
import PostVideoModel from '../../../models/post/post_video_module';
import log from '../../../services/logger_service';

export default function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(postVideoActions.postVideoLoading({}, store));
    return PostVideoModel.fetch(params, store)
      .then(function handlePostDetailData(resp) {
        dispatch(postVideoActions.postVideoLoaded(resp.data, store));
      })
      .catch(function handleUserError(err) {
        dispatch(postVideoActions.postVideoLoadError(err, store));
        log.error(err, `Error in post video actions, message: ${err.message}`);
      });
  };
}
